import React from 'react';
import Graph from './components/Graph';

function App() {
  return <Graph />;
}

export default App;
